import { AccountSummaryModelDto } from '@treasury/api/channel';

export const defaultAccountSummaryModelDto: AccountSummaryModelDto = {
    isNew: true,
    showAccountNickName: false,
    number: '',
    type: '',
    name: '',
    currentBalance: 0,
    availableBalance: 0,
    collectedBalance: 0,
    accruedInterest: 0,
    interestRate: 0,
    interestPaidYtd: 0,
    interestPaidPreviousYtd: 0,
};
